import { Product } from "@core/types";
import { useConfig } from "../providers/config";

export const useCreatePriceMarkup = (product: Product): Record<"__html", string> => {
  const { usePriceHTML } = useConfig();

  if (!product.price) {
    return {
      __html: "",
    };
  }

  return { __html: usePriceHTML && product.priceHtml ? product.priceHtml : product.price + " ₽" };
};
